import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { associateCardWithUser, getToken, getUserPoolClient, setMFPUserSettings } from '../../services/api';
import Loading from '../Loading'
import { useLocalStorage } from '../../services/hooks/useLocalStorage';
import { trackPromise } from 'react-promise-tracker';
import { STC_ID, STRATUS_ID } from '../../services/constants';

const Auth = (_props) => {
    const location = useLocation();
    const history = useHistory();

    const [_user, setUser] = useLocalStorage('user', '');
    const [_tenant, setTenant] = useLocalStorage('tenant', undefined);
    const [_accessToken, setAccessToken] = useLocalStorage('accessToken', undefined);
    const [_idToken, setIdToken] = useLocalStorage('idToken', undefined);
    const [_refreshToken, setRefreshToken] = useLocalStorage('refreshToken', undefined);
    const [_client, setClient] = useLocalStorage('client', undefined);
    const [stratus] = useLocalStorage("stratus", false);

    useEffect(() => {
        async function handleLogin() {
            const params = new URLSearchParams(location.search);
            const error = params.get('error');
            if (error) {
                const description = params.get('error_description');
                console.log(`Error received in auth callback: ${error} :: ${description}`);
                let header = 'Login Error';
                let subheader = 'Unable to login with the credentials provided, please try again';
                if (error === 'invalid_request' && description.includes('invalid_client')) {
                    header = 'Client Secret expired';
                    subheader = 'Update the Client Secret in Microsoft Entra ID, then re-enter the new value in your tenant identity provider settings.';
                }
                history.push(`/error?header=${encodeURIComponent(header)}&subheader=${subheader}`);
                return
            }
            const code = params.get('code');
            const state = params.get('state');
            const paramState = window.atob(decodeURIComponent(escape(state)));
            const [pPoolId, pDomain, pClientID, pCallback, pRegion, tenantId, tenantName, tenantPlan, cardId] = paramState.split('|', 9);
            const client = await getUserPoolClient(pPoolId, pClientID, pRegion);
            const clientSecret = client.client.ClientSecret
            const token = await getToken(pDomain, pRegion, code, pClientID, clientSecret, pCallback);
            const accessToken = token.access_token;
            const idToken = token.id_token;
            const refreshToken = token.refresh_token;
            // Get username. Username is different for SSO and Cognito users
            const decodedIdToken = jwtDecode(idToken);
            const decodedAccessToken = jwtDecode(accessToken);
            const user = decodedIdToken.email || decodedAccessToken.username

            if (cardId) {
                try {
                    await trackPromise(associateCardWithUser(cardId, decodedAccessToken.sub, pDomain, accessToken));
                } catch (e) {
                    console.error('Error associating card with user!');
                    console.error(e);
                }
            }

            let appId = STC_ID;
            if (stratus) {
                appId = STRATUS_ID;
            }

            setUser(user);
            setTenant({ id: tenantId, name: tenantName, slug: pDomain, region: pRegion, plan: tenantPlan });
            setIdToken(idToken);
            setAccessToken(accessToken);
            setRefreshToken(refreshToken);
            setClient(client.client);
            await setMFPUserSettings({
                accessToken,
                idToken,
                refreshToken,
                user,
                client: client.client,
                tenant: { id: tenantId, name: tenantName, slug: pDomain, region: pRegion }
            }, appId);
            // Clear MarketPlace session
            /*
            const redirectUrlBase = `https://${pDomain}.auth.${pRegion}.amazoncognito.com/logout`
            const logoutParams = new URLSearchParams({
                client_id: client.client.ClientId,
                logout_uri: `${window.location.protocol}//${window.location.host}`,
            })
            const redirectUrl = `${redirectUrlBase}?${logoutParams.toString()}`;

            window.location = redirectUrl
            */
           history.push('/');
        }
        handleLogin();
    // eslint-disable-next-line
    }, [history, location.search]);

    return (
        <Loading />
    )
}

export default Auth